import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { updateSearchParameters } from '../../../store/actions/search'
import { objectEquals, parseUrlParams, mergeSearch } from '../../cdl-react-components/utilities'
import { logError } from '../../../utilities'

const UrlParameterSync = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const parameters = useSelector(_ => _.search.parameters)
    const [lastParameters, setLastParameters] = useState({})

    useEffect(() => {
        let params = []

        let { query } = parseUrlParams()
        if (query) {
            try {
                params = JSON.parse(decodeURIComponent(query))
            }
            catch (e) {
                logError('Error parsing search params from url.')
            }
        }
        // Else { no params to build the search from }

        dispatch(updateSearchParameters(params))
    }, [dispatch])

    useEffect(() => {
        if (!objectEquals(lastParameters, parameters)) {            
            // New params: need to add them to url in search bar
            const query =
                parameters &&
                    parameters.length > 0 ?
                    `query=${JSON.stringify(parameters.map(x => ({ ...x, value: encodeURIComponent(x.value) })))}` :
                    `query=`
            const search = mergeSearch(window.location.search, query)

            navigate(window.location.pathname + search)
            setLastParameters(parameters)
        }
        // Else { no new search parameters to add to url }
    }, [parameters, lastParameters, navigate])

    return null
}

export default UrlParameterSync